module.exports = __webpack_public_path__ + "static/media/Rupa Swara Jiwa.a098a084.png";